module.exports = __webpack_public_path__ + "img/f_green.6edd0f0f.svg";